module.exports = __webpack_public_path__ + "img/chart.261d1d7c.svg";